import React from 'react';

import ErrorIcon from 'icons/ic-error-large.svg';
import LoadingIcon from 'icons/loading.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import TextButton from 'components/application/buttons/TextButton';

export default function DownloadReportModalContent({
  closeModal,
  isReportError,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix:
      'mobileTrainingProfile.components.homeScreen.DownloadReportModalContent',
  });

  const { t: i18nTCommon } = useTranslation('common');

  return (
    <>
      <div className='tw-flex tw-flex-col tw-items-center tw-p-6'>
        <div className='tw-apply-loading-spinner--blue-light'>
          {isReportError ?
            <ErrorIcon
              className='[&_path]:tw-fill-red-600'
              height={48}
              width={48}
            />
          : <LoadingIcon height={48} width={48} />}
        </div>
        <div className='tw-mt-2 tw-text-center tw-text-l tw-font-semibold'>
          {isReportError ?
            i18nTCommon('shared.reportNotGenerated')
          : i18nT('title.default')}
        </div>
        <div className='tw-mt-2 tw-text-center'>
          {isReportError ?
            i18nTCommon('shared.errors.tryAgainOrContactSupport')
          : i18nTCommon('training.reportWillAutoDownload')}
        </div>
      </div>
      <div className='tw-flex tw-justify-center tw-border-0 tw-border-t-1 tw-border-solid tw-border-grey-100 tw-p-4'>
        <TextButton color='blue' onClick={closeModal} size='md'>
          {i18nTCommon('shared.close')}
        </TextButton>
      </div>
    </>
  );
}

DownloadReportModalContent.propTypes = {
  isReportError: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};
